var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"text-center grey--text title pa-6 notification-disabled-message",attrs:{"data-testid":"notification-not-enabled-message__main"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }